var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-chip',{attrs:{"color":_vm.item.color,"text-color":_vm.item.network
      ? _vm.getColorForVlanType(_vm.item.network.type, false, 1, true)
      : undefined}},[_c('v-icon',[_vm._v(_vm._s(_vm.item.icon))]),_vm._v("   "),_c('span',{staticClass:"font-weight-medium"},[_vm._v(_vm._s(_vm.item.repr))]),_c('v-chip',{staticClass:"font-weight-medium",attrs:{"small":""}},[_vm._v(" Vlan ID: "+_vm._s(_vm.item.vid))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }